import { accountActions } from './accountActions';
import { categorySourceActions } from './categorySourceActions';
import { appConfigAction } from './common/appConfigAction';
import { commonActions } from './commonActions';

import { dictionaryActions } from './dictionaryAction';
import { hocSinhActionsWrapper } from './hoc-sinh/hocSinhActionsWrapper';
import { notifyActions } from './notify/notifyAction';
import { loaiPhongActions } from './phong-hoc/loaiPhongActions';
import { phongHocActions } from './phong-hoc/phongHocActions';
import { uploadActions } from './upload-file/uploadActions';

import { boDoiCongAnActions } from './bodoi-congan/boDoiCongAnActions';
import { conCbnvActions } from './con-cbnv/conCbnvActions';
import { nguonBietToiActions } from './crm-category/nguonBietToiAction';
import { nguonBietToiTypeActions } from './crm-category/nguonBietToiTypeAction';
import { crmHocSinhActions } from './crm-hocsinh/crmHocSinhAction';
import { crmPhuHuynhActions } from './crm-phuhuynh/crmPhuHuynhAction';
import { chienDichActions } from './crm-survey/chienDichAction';
import { crmSurveyFormActions } from './crm-survey/crmSurveyFormAction';
import { crmSurveyFormQuestionActions } from './crm-survey/crmSurveyFormQuestionAction';

import { sucKhoeActions } from './danh-muc/sucKhoeActions';
import { dmEmailConfigAction } from './email/dmEmailConfig';
import { emailFormActions } from './email/emailFormActions';
import { emailTemplateActions } from './email/emailTemplateActions';
import { formActions } from './form/formAction';
import { formEditorActions } from './form/formEditorAction';
import { formItemActions } from './form/formItemAction';
import { formEditorTypeActions } from './form/formItemEditorTypeAction';
import { formRegisterResultActions } from './form/formRegisterResultAction';
import { hocSinhAceActions } from './hoc-sinh/hocSinhAceAction';
import { hocSinhAceChiTietActions } from './hoc-sinh/hocSinhAceChiTietAction';
import { loaiGiayToAction } from './loai-giay-to/loaiGiayToAction';
import { thongKeSiSoActions } from './thong-ke/thongKeSiSoActions';
import { thongTinCbnvActions } from './thongtin-cbnv/thongTinCbnvAction';
import { foCaAnActions } from './thuc-don/foCaAnAction';
import { foCaAnTruongActions } from './thuc-don/foCaAnTruongAction';
import { foMonAnChiTietActions } from './thuc-don/foMonAnChiTietAction';
import { foThucDonActions } from './thuc-don/foThucDonAction';
import { trangThaiHocSinhAction } from './trang-thai-hoc-sinh/trangThaiHocSinhAction';
import { trangThaiPhuHuynhAction } from './trang-thai-phu-huynh/trangThaiPhuHuynhAction';
import { danhMucActionsWrapper } from './danh-muc/danhMucActionsWrapper';
import { loaiSucKhoeActions } from './danh-muc/loaiSucKhoeActions';
import { giaoVienActions } from './danh-muc/giaoVienAction';
import { thongKeCSKHActions } from './thong-ke/thongKeCSKHActions';
import { thongKeCRMActions } from './thong-ke/thongKeCRMActions';
import { emailActions } from './email/emailActions';


export const actions = {
    account: accountActions,
    appConfig: appConfigAction,
    giaoVien: giaoVienActions,

    categorySource: categorySourceActions,
    common: commonActions,
    dictionary: dictionaryActions,

    hocSinh: hocSinhActionsWrapper,
    loaiPhong: loaiPhongActions,
    phongHoc: phongHocActions,
    uploadFile: uploadActions,
    notify: notifyActions,
    formWrapper: {
        form: formActions,
        formItem: formItemActions,
        formEditor: formEditorActions,
        formEditorType: formEditorTypeActions,
        formRegisterResult: formRegisterResultActions
    },
    crmSurveyFormWrapper: {
        crmSurveyFormQuestion: crmSurveyFormQuestionActions,
        crmSurveyForm: crmSurveyFormActions,
        chienDich: chienDichActions,
        trangThaiHocSinh: trangThaiHocSinhAction,
        trangThaiPhuHuynh: trangThaiPhuHuynhAction,
        loaiGiayTo: loaiGiayToAction
    },
    crmCategoryWrapper: {
        nguonBietToi: nguonBietToiActions,
        nguonBietToiType: nguonBietToiTypeActions
    },
    emailWrapper: {
        dmEmailConfig: dmEmailConfigAction,
        template: emailTemplateActions,
        form: emailFormActions,
        email:emailActions
    },
    crmHocSinh: crmHocSinhActions,
    thucDonWrapper: {
        caAn: foCaAnActions,
        caAnTruong: foCaAnTruongActions,
        monAnChiTiet: foMonAnChiTietActions,
        thucDon: foThucDonActions
    },
    crmPhuHuynh: crmPhuHuynhActions,

    hocSinhAce: hocSinhAceActions,
    hocSinhAceChiTiet: hocSinhAceChiTietActions,
    thongTinCbnv: thongTinCbnvActions,
    conCbnv: conCbnvActions,
    boDoiCongAn: boDoiCongAnActions,
    thongKe: {
        thongKeSiSo: thongKeSiSoActions,
        cskh: thongKeCSKHActions,
        crm: thongKeCRMActions
    },
    danhMucWrapper: danhMucActionsWrapper,
    sucKhoe: {
        sucKhoe: sucKhoeActions,
        loaiSucKhoe: loaiSucKhoeActions
    },
}

